import { format, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { builderSampleWeek } from "../../lib/metadata-builder/sample-schedule";
import { endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { SchedulePeriodForm } from "../schedule/SchedulePeriod";

export function BuilderPeriodInputs() {
  const { t } = useTranslation();
  const date = useMetadataBuilderStore(state => state.sampleDate);
  const timezone = useMetadataBuilderStore(state => state.sampleTimezone);
  const setDate = useMetadataBuilderStore(state => state.setSampleDate);
  const setTimezone = useMetadataBuilderStore(state => state.setSampleTimezone);
  return <div className="space-y-2 rounded border border-neutral-200 p-2" onFocusCapture={endMetadataMerge}>
    <p className="text-neutral-500">{t("builder.inputs.periodHelp")}</p>
    <SchedulePeriodForm week={builderSampleWeek(date)} selectedDate={parseISO(date)} timezone={timezone}
      warnPastWeek={false} onDateChange={date => setDate(format(date, "yyyy-MM-dd"))} onTimezoneChange={setTimezone} />
  </div>;
}
